import i18n from 'i18next';

export const locales = {
    fr: 'fr-FR',
    en: 'en-US',
    es: 'es-ES',
    it: 'it-IT',
    pt: 'pt-PT',
    nl: 'nl-NL',
    de: 'de-DE',
    da: 'da-DK',
    sv: 'sv-SE',
    nb: 'nb-NO',
    hr: 'hr-HR'
    // hu: 'hu-HU',
    // el: 'el-GR',
    // tr: 'tr-TR'
};

export const languages = Object.keys(locales);

export const namespaces = [
    'billing',
    'collection',
    'common',
    'countries',
    'dashboard',
    'destination',
    'error',
    'exchange',
    'fillingpanel',
    'global',
    'home',
    'messaging',
    'rating',
    'search',
    'sponsorship',
    'subscription',
    'tour',
    'upload',
    'url',
    'user',
    'global'
];

i18n.init({
    debug: false,
    getAsync: true,

    fallbackLng: 'en',
    whitelist: languages,

    // have a common namespace used around the full app
    ns: namespaces,
    defaultNS: 'common',

    returnNull: false,
    returnEmptyString: false,

    interpolation: {
        prefix: '%{',
        suffix: '}',
        escapeValue: false // not needed for react
    },
    keySeparator: '#',
    react: {
        defaultTransParent: 'span'
    }
});

// if (process.env.NODE_ENV === 'test') {
namespaces.forEach((namespace) => {
    languages.forEach((lang) => {
        const ressource = require(`../public/locale/${lang}/${namespace}.json`);
        i18n.addResources(lang, namespace, ressource);
    });
});
// }

// Hack to load i18n asynchronously  (https://github.com/i18next/i18next/issues/636)
const htmlTag = typeof document !== 'undefined' ? document.documentElement : null;
if (htmlTag && htmlTag.getAttribute('lang')) {
    i18n.changeLanguage(htmlTag.getAttribute('lang'));
}

export default i18n;
